import React, {Component} from 'react';
import PropTypes from 'prop-types';
import postscribe from "postscribe";
import './TwillContent.scss';
import {filterHTMLTwill} from "../../helpers/filters";
import {twillBase} from '../../config/API';

class TwillContent extends Component {

    static propTypes = {
        id: PropTypes.string.isRequired,
        // eslint-disable-next-line react/no-unused-prop-types
        path: PropTypes.string.isRequired,
    };

    static defaultProps = {
        id: 1
    };

    state = {
        darkMode: false,
        body: null,
        stylesLoaded: false,
        scriptsLoaded: false,
    }




async componentDidMount() {
        await this.loadExternalStylesheet();

        // Remove trailing slash
        const url = `${twillBase}${this.props.path}`.replace(/\/$/, '');

        await fetch(url).then(res => res.text()).then(data => {


            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');
            const bodySelector = html.querySelector('.mx-auto');
            const innerHTML = bodySelector.innerHTML;


            if (innerHTML.length) this.setState({
                body: innerHTML,
                darkMode: bodySelector.classList.contains('darkMode')
            })
            const scriptUrl = this.extractEmailDecodeSrc(data);
            if (scriptUrl) {
                postscribe('#app', `<script src="${scriptUrl}" data-cfasync="false"></script>`);
            }

        }).catch(err => {
            console.log(err);
            return null;
        });

        await this.loadExternalScripts();
    }

    componentDidUpdate() {
        const accordions = document.querySelectorAll('.js-accordion');
        if (!accordions || !accordions.length) return;

        accordions.forEach(accordion => {
            if (accordion.getAttribute('data-accordion-prefix-classes') === 'minimalist') return;

            accordion.setAttribute('data-accordion-prefix-classes', 'minimalist');
            // Add Header class since Drupal strips it
            accordion.querySelectorAll(':scope > h1,h2,h3,h4,h5,h6').forEach(headline => {
                headline.classList.add('js-accordion__header')
            });

            // eslint-disable-next-line no-undef
            van11yAccessibleAccordionAria().attach();
        });
    }

    extractEmailDecodeSrc = (htmlString) => {
        const regex = /<script[^>]+src=["']([^"']*email-decode\.min\.js)["'][^>]*>/i;
        const match = htmlString.match(regex);

        if (match && match[1]) {
            const src = match[1];
            const base = 'https://www.marketaxess.com';
            return new URL(src, base).href;
        }

        return null;
    }


    loadExternalStylesheet = async () => {
        const manifestPath = '/external-app-css';
        const url = `${twillBase}${manifestPath}`.replace(/\/$/, '');

        await fetch(url).then(res => res.text()).then(filePath => {
            if (!this.state.stylesLoaded) {
                postscribe(`#twillContent${this.props.id}`, `<link rel="stylesheet" href="${filePath}">`);
                this.setState({stylesLoaded: true});
            }
        }).catch(err => {
            console.log(err);
            return null;
        });
    };

    loadExternalScripts = async () => {
        const manifestPath = '/external-app-js';
        const url = `${twillBase}${manifestPath}`.replace(/\/$/, '');

        await fetch(url).then(res => res.text()).then(filePath => {
            if (!this.state.scriptsLoaded) {
                postscribe(`#twillContent${this.props.id}`, `<script src="${filePath}"></script>`);
                this.setState({scriptsLoaded: true});
            }
        }).catch(err => {
            console.log(err);
            return null;
        });
    };

    render() {
        return (
            <div id={`twillContent${this.props.id}`}>
                {this.props.id && this.state.body ? (
                    <div id="twexternal">
                        <div className={`${this.state.darkMode ? 'darkMode' : null}`}>
                            {filterHTMLTwill(this.state.body, true, false, false, false)}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default TwillContent ;




// WEBPACK FOOTER //
// ./frontend/components/TwillContent/TwillContent.jsx